var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { T } from '../../helpers/i18n';
import { BlockCheckins } from './Blocks/BlockCheckins';
import { BlockPayments } from './Blocks/BlockPayments';
import { BlockLogo } from './Blocks/BlockLogo';
import { BlockUser } from './Blocks/BlockUser';
import { BlockDate } from './Blocks/BlockDate';
import { BlockTexto } from './Blocks/BlockTexto';
import { BlockServicePacket } from './Blocks/BlockServicePacket';
import { BlockSeparator } from './Blocks/BlockSeparator';
import { BlockTickets } from './Blocks/BlockTickets';
import { BlockAditionalInfo } from './Blocks/BlockAditionalInfo';
import { Align, FontSize } from '../../modules/ReceiptLayouts/Model';
import { PrintRefund } from './PrintRefund';
import { BlockSpaces } from './Blocks/BlockSpaces';
import { _width, widthFunc } from './helpers/Const';
export var RenderPacketTicket = function (_a) {
    var item = _a.item, operationline = _a.operationline, onRefund = _a.onRefund;
    // console.log('operationline: ', operationline)
    var image = operationline ? "".concat(operationline.businessUnit.image) : '';
    // console.log('image: ', image)
    return (React.createElement("div", { style: __assign({ display: 'flex', flexDirection: 'column', justifyContent: Align.Center, alignItems: Align.Center, borderTop: '3px dotted black', borderLeft: '1px solid black', borderRight: '1px solid black', borderBottom: '3px dotted black', 
            /*marginTop: 50,*/
            backgroundColor: 'white' }, widthFunc(1, _width)) },
        React.createElement(PrintRefund, { ticket: item, onPrint: function () { return window.print(); }, onRefund: function () { return onRefund(item); } }),
        React.createElement(BlockLogo, { image: image, align: Align.Center }),
        React.createElement(BlockUser, { user: item.username, align: Align.Center }),
        React.createElement(BlockDate, { fecha: item.datecheck, fontSize: FontSize.normal, align: Align.Center }),
        React.createElement(BlockTexto, { texto: T('packetticket'), fontSize: 25, align: Align.Center, bold: true }),
        React.createElement(BlockSeparator, { char: '-' }),
        React.createElement(BlockServicePacket, { operationline: item.operationLineName, packetName: item.packetName }),
        React.createElement(BlockSeparator, { char: '-' }),
        React.createElement(BlockSpaces, null),
        React.createElement(BlockCheckins, { lines: item.lines }),
        React.createElement(BlockSeparator, { char: '-' }),
        React.createElement(BlockPayments, { item: item }),
        React.createElement(BlockSeparator, { char: '-' }),
        React.createElement(BlockAditionalInfo, { aditionalInfo: item.aditionalInfo }),
        React.createElement(BlockTexto, { texto: 'Incluye', align: Align.Center, fontSize: FontSize.big }),
        React.createElement(BlockTickets, { item: item }),
        React.createElement(BlockTexto, { texto: 'Gracias por su visita', align: Align.Center })));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/Ticket/RenderPacketTicket.tsx
// module id = 1153
// module chunks = 0